import React, { Component } from 'react';

class DateLineChartPlaceholder extends Component {
  render() {
    return <div className="chart placeholder" />;
  }
}

export default DateLineChartPlaceholder;
